import React, { useState, useEffect, useMemo } from 'react';
import { Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { EmailOutlinedIcon, UploadFileOutlinedIcon } from 'icons/materialIcons';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import TeamIconComponent from 'team/shared/components/TeamIconComponent';
import TeamAddMemberHeader from 'team/components/members/TeamAddMemberHeader';
import TeamAddMemberSidebar from 'team/components/members/TeamAddMemberSidebar';
import TeamAddMemberContent from 'team/components/members/TeamAddMemberContent';

const TeamAddMemberContainer = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedOption, setSelectedOption] = useState('add-email');
    const [formData, setFormData] = useState(null);
    const [isValid, setIsValid] = useState(false);

    // Read the option from URL parameters
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const option = urlParams.get('option');
        if (option && ['add-email', 'import-csv', 'create-pages', 'sync-ad', 'sync-eventbrite'].includes(option)) {
            setSelectedOption(option);
        }
    }, [location.search]);

    // Menu options configuration
    const menuOptions = useMemo(() => [
        {
            key: 'add-email',
            title: 'Add by Email',
            description: 'Add teammates via email address',
            icon: <EmailOutlinedIcon />
        },
        {
            key: 'import-csv',
            title: 'Import via CSV',
            description: 'Add teammates via CSV file',
            icon: <UploadFileOutlinedIcon />
        },
        {
            key: 'create-pages',
            title: 'Add Company Pages',
            description: 'Pages for the company that are NOT assigned to a team member',
            icon: <BusinessOutlinedIcon />
        },
        {
            key: 'sync-ad',
            title: 'Sync Active Directory',
            description: 'Sync teammates from Microsoft Active Directory',
            icon: <TeamIconComponent name="Active Directory" size="1.25rem" marginRight="0" />
        },
        {
            key: 'sync-eventbrite',
            title: 'Sync Eventbrite',
            description: 'Create Touch accounts from the Eventbrite attendees',
            icon: <TeamIconComponent name="Eventbrite" size="1.25rem" marginRight="0" />
        }
    ], []);

    const handleBackToMembers = () => {
        navigate('/team/members');
    };

    const handleMenuClick = (optionKey) => {
        setSelectedOption(optionKey);
        // Reset form data when switching options
        setFormData(null);
        setIsValid(false);
    };

    const handleDataChange = (data) => {
        setFormData(data);
    };

    const handleValidationChange = (valid) => {
        setIsValid(valid);
    };

    return (
        <Box sx={{ height: '100vh', padding: 3, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <TeamAddMemberHeader onBack={handleBackToMembers} />

            <Box sx={{
                flex: 1,
                borderRadius: '0.5rem',
                overflow: 'hidden',
                backgroundColor: '#ffffff',
                display: 'flex',
                flexDirection: 'column',
            }}>
                <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
                    <TeamAddMemberSidebar
                        menuOptions={menuOptions}
                        selectedOption={selectedOption}
                        onMenuClick={handleMenuClick}
                    />

                    <TeamAddMemberContent
                        selectedOption={selectedOption}
                        onDataChange={handleDataChange}
                        onValidationChange={handleValidationChange}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default TeamAddMemberContainer;
